var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMasterCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 0.5H39.3333C41.6147 0.5 43.5 2.43605 43.5 4.86957V27.1304C43.5 29.5639 41.6147 31.5 39.3333 31.5H4.66667C2.38532 31.5 0.5 29.5639 0.5 27.1304V4.86957C0.5 2.43605 2.38532 0.5 4.66667 0.5Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeMiterlimit: 3.8637
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4893 23.4382C20.884 24.8608 18.8017 25.7195 16.5264 25.7195C11.4493 25.7195 7.3335 21.4441 7.3335 16.1701C7.3335 10.896 11.4493 6.62061 16.5264 6.62061C18.8017 6.62061 20.884 7.47934 22.4893 8.90183C24.0945 7.47934 26.1768 6.62061 28.4523 6.62061C33.5293 6.62061 37.6452 10.896 37.6452 16.1701C37.6452 21.4441 33.5293 25.7195 28.4523 25.7195C26.1768 25.7195 24.0945 24.8608 22.4893 23.4382Z",
    fill: "#ED0006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4895 23.4382C24.466 21.6866 25.7194 19.0804 25.7194 16.1701C25.7194 13.2597 24.466 10.6534 22.4895 8.90183C24.0947 7.47934 26.177 6.62061 28.4525 6.62061C33.5294 6.62061 37.6452 10.896 37.6452 16.1701C37.6452 21.4441 33.5294 25.7195 28.4525 25.7195C26.177 25.7195 24.0947 24.8608 22.4895 23.4382Z",
    fill: "#F9A000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4882 23.4382C24.4648 21.6866 25.7181 19.0803 25.7181 16.1701C25.7181 13.2597 24.4648 10.6534 22.4882 8.90186C20.5117 10.6534 19.2583 13.2597 19.2583 16.1701C19.2583 19.0803 20.5117 21.6866 22.4882 23.4382Z",
    fill: "#FF5E00"
  })));
}

export default SvgMasterCard;